export function isApiResource(value) {
    return (typeof value === 'object' &&
        value !== null &&
        '@type' in value &&
        typeof value['@type'] === 'string');
}
export function isApiResourceOfType(value, type) {
    return isApiResource(value) && value['@type'] === type;
}
